import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";
import { MentorForecastingDashboard } from "@/components/mentor-forecasting";

export const Route = createFileRoute("/_authenticated/mentor-forecasting/")({
  component: MentorForecasting,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "admin-analytics");
  },
});

function MentorForecasting() {
  return <MentorForecastingDashboard />;
}
